import { server } from 'config/environment'

function a(userAgent?: string) {
  return userAgent || (server ? '' : navigator.userAgent)
}

export function isMobile(userAgent?: string) {
  userAgent ||= server ? '' : navigator.userAgent
  return /(android|iphone|mobile)/i.test(a(userAgent))
}

export function isTablet(userAgent?: string) {
  return /(ipad)/i.test(a(userAgent))
}

export function isSafari(userAgent?: string): boolean {
  return /^((?!chrome|android).)*safari/i.test(a(userAgent))
}
